merge = require('node_modules/turf-merge')

# This class presents the drawing tools on the map (by extending MfButtonGrid)
# and all the standard behavior for the drawing tools, including additive, subtractive,
# shape merging, deletion, undo, etc.
class L.Control.MfDraw extends L.Control.MfButtonGrid

    constructor: () ->
        super()
        @setDefaults()
        L.drawLocal.draw.handlers.rectangle.tooltip.start = 'Click or drag to draw rectangle'
        L.drawLocal.draw.handlers.circle.tooltip.start = 'Click or drag to draw circle'

    setStyle: () =>
        @fire('zone:style')

    setFinishedStyle: (opacity, weight = 2, color = '#0F0') =>
        @options.finished.style = {
            'fillOpacity': opacity,
            'weight': weight,
            'color': color
        }

    # set default options.
    setDefaults: () =>
        @options =
            position: 'topleft'
            draw:
                style:
                    color: '#008161'
                    width: 3
            finished:
                style:
                    'fillOpacity': 0.6,
                    'weight': 2,
                    'color': '#0F0'
            colors:
                style: (mode) =>
                    if @mode is 'add'
                        return {
                            color: '#008000'
                            width: 3
                            icon: { iconSize: [4, 4] }
                        }
                    if @mode is 'subtract'
                        return {
                            color: '#FF0000'
                            width: 3
                        }
            toolbars: [
                { # Box/Group
                    rows: [
                        [ # Row
                            # Each object here defines a button / column in the row

                            # data name, symbol, toggle
                            { name: 'draw-poly-add', html: '<i class="drawicon-poly-green"></i>', toggle: true },
                            { name: 'draw-poly-sub', html: '<i class="drawicon-poly-red"></i>', toggle: true }
                        ],
                        [
                            { name: 'draw-rect-add', html: '<i class="drawicon-rect-green"></i>', toggle: true },
                            { name: 'draw-rect-sub', html: '<i class="drawicon-rect-red"></i>', toggle: true },
                        ],
                        [
                            { name: 'draw-circle-add', html: '<i class="drawicon-circle-green"></i>', toggle: true },
                            { name: 'draw-circle-sub', html: '<i class="drawicon-circle-red"></i>', toggle: true },
                        ]
                    ]
                }
                {
                    style: {
                        width: '60px'
                    }
                    rows: [
                        # [
                        #     {name: 'draw-select', html:  '<i class="fa fa-hand-o-up"></i>', toggle: true},
                        # ],
                        # [
                        #     {name: 'draw-delete', html:  '<i class="fa fa-trash-alt"></i>', toggle: true}
                        # ],
                        [
                            { name: 'draw-undo', html: '<span><i class="fa fa-reply"></i> Undo </span>', toggle: false, style: { width: '61px', 'text-decoration': 'none' } }
                        ]
                    ]
                }
            ]

    # When the control is added to the map, we initialize a *ton* of
    # callback handlers, which will respond to button clicks and cause the normally
    # expected actions to happen
    onAdd: (map) ->
        @map ?= map
        @mode = null
        @current_tool = null
        container = super(map)

        # transformations applied to newly drawn shapes before we
        # reload the visible layer. Effectively, this lets us
        # supply additional clipping rules, or make copies of
        # newly drawn data before we update the map.
        #
        # The standard shape unioning / differencing is implemented
        # as a transform
        @clipping_transforms = []
        @addTransform @_mergeNewShape


        @addCallback '*', @_anyButtonPressed
        @addCallback 'draw-poly-sub,draw-rect-sub,draw-circle-sub,draw-poly-add,draw-rect-add,draw-circle-add', @_setReenable
        @addCallback 'draw-poly-sub,draw-rect-sub,draw-circle-sub', @_subtractiveButtonPressed
        @addCallback 'draw-poly-add,draw-rect-add,draw-circle-add', @_additiveButtonPressed
        @addCallback 'draw-poly-add,draw-poly-sub', @_drawPolygon
        @addCallback 'draw-rect-add,draw-rect-sub', @_drawRectangle
        @addCallback 'draw-circle-add,draw-circle-sub', @_drawCircle
        # @addCallback 'draw-select', @_selectPressed
        @addCallback 'draw-undo', @_undoPressed
        # @addCallback 'draw-delete', @deleteZone
        @map.on 'draw:created', @_handleDrawComplete

        @on 'mfdraw:shape-added', () =>
            # If we've finished drawing a shape and we're
            # allowing re-enabling of the current tool, then
            # re-click the button to kick it off again
            if @reenable_onfinish
                @getButton(@last_pressed).trigger('click')

        return container


    deleteZone: (e) =>
        @fire('zone:delete')

    onRemove: () =>
        @map.off 'draw:created', @_handleDrawComplete


    # Adds a function to the clipping transformations list
    # The callback should take the argument:
    #   - type = type of the new shape drawn (circle, rectangle, polygon)
    #   - layer = the newly drawn shape
    #   - combined = geojson representing the result of the previous transfom
    #   - previous_shapes = the feature group representing shapes that were drawn previously -
    #       this is the same as @layer
    #
    addTransform: (cb) =>
        # 'Enter transform function'
        @clipping_transforms.push cb

    # Removes a method from the clipping transformations list
    removeTransform: (cb) =>
        # 'enter removeTransform'
        _.remove @clipping_transforms, cb

    # Set the active drawing layer. This is the feature group that
    # all the drawn shapes will be placed in.
    setLayer: (layer) =>
        # 'enter setLayer'
        @layer = layer

    _undoPressed: () =>
        # @selectBtn(@last_pressed)
        # let the drawing handler take care of undo if we gave it a custom method
        # if @current_tool?.canUndo?()
        #     @fire('mfdraw:poly-removed') if @current_tool.canUndo() is 1
        #     @current_tool.undo()
        # else
            # let the service handle the undo

        @current_tool.disable() if @current_tool
        @fire('mfdraw:undo')

    # When we click any of the buttons, reset the option to
    # reenable the tool after completion, disable any current
    # tool, and make the current button be trackde as the "last_pressed"
    _anyButtonPressed: (e, name) =>
        @reenable_onfinish = false
        @last_pressed = name
        @current_tool?.active = false
        @current_tool?.h?.disable?()
        @current_tool?.disable?()
        @fire('mfdraw:tool-selected')

    _setReenable: () =>
        @reenable_onfinish = true


    # Handles joining newly drawn shapes to the saved set. If we're in additive
    # mode, the new shapes are unioned against the previously drawn shapes, and
    # if we're in subtractive, we use difference.
    #
    # Once the new shapes are clipped, we clear out the visible @layer and
    # add in the new shapes
    _handleDrawComplete: (e) =>
        # alias layer type and layer
        type = e.layerType
        layer = e.layer
        combined = null
        @layer_operation = @mode

        if type is 'circle'
            # Convert the circle to a polygon representation so we can geoJSON it
            layer = new L.PolyCircle(layer.getLatLng(), layer.getRadius(), { nodes: 20 })
            layer = layer.getPoly()

        # prevent accidental drags and clicks from making tiny shapes
        if turf.area(layer.toGeoJSON()) < 0.1
            # just re-enable the tool and exit
            @getButton(@last_pressed).trigger('click')
            return

        # call the cb on data
        for cb in @clipping_transforms
            combined = cb(type, layer, combined, @layer)

    _finishDrawing: (combined, cb = false, update_undo = true) =>
        # if there werent changes then don't bother redrawing
        if @checkNetChange(combined)
            # if nothing changed just re-activate the tool and return
            if @reenable_onfinish
                @getButton(@last_pressed).trigger('click')

            return

        # update the undo stack by default
        @fire('mfdraw:undo-update', { previous: @layer.toGeoJSON() }) if update_undo
        # clear current layers
        @layer.clearLayers()
        @addGeometryToLayer(combined)
        # fire event to update
        @fire('mfdraw:shape-added')
        if cb isnt false
            cb()

    addGeometryToLayer: (geometry) =>
        if geometry.features
            geometry = geometry.features
        else if geometry.geometry.type is 'MultiPolygon'
            geometry = (turf.polygon(coordinate) for coordinate in geometry.geometry.coordinates)
        else
            geometry = [geometry]
        # iterate over each layer
        L.geoJson({ type: "FeatureCollection", features: geometry }).eachLayer (l) =>
            # set style on l of combined
            l.setStyle(@options?.finished?.style ? {})
            # add layer to the front end
            @layer.addLayer(l)

    _mergeNewShape: (type, layer, combined, previous_shapes) =>
        if previous_shapes?.getLayers?().length > 0
            # get active shape
            poly = @_getCurrentAsGeojson()

            # TODO: once turf finalizes the new intersect / clipping stuff,
            # switch the to `turf.union` and `turf.difference` instead of
            # using `customturf`.
            # 'either add or subtract'
            if @mode is 'add'
                l = layer.toGeoJSON()
                l.properties = {}
                poly.properties = {}
                # combined = customturf.union(poly, l)

                combined = turf.union(poly, l)

            else if @mode is 'subtract'
                # combined = customturf.difference(poly, layer.toGeoJSON())
                combined = turf.difference(poly, layer.toGeoJSON())
                # if we removed the last of the area
                if not combined
                    @fire('mfdraw:remove-all')
        else
            combined = layer?.toGeoJSON?()

        if not combined
            @_setPgisParams(poly, layer?.toGeoJSON?(), @mode)
            return null

        @_setPgisParams(combined, null)

        return combined

    _setPgisParams: (a, b, c = 'union') =>
        @layer_one = a
        @layer_two = b
        @layer_operation = c

    _getPgisParams: () =>
        return { layer_one: @layer_one, layer_two: @layer_two, operation: @layer_operation }

    _pgis: (operation, cb = false) =>
        if not cb
            @fire("pgis:#{operation}")
        else
            @fire("pgis:#{operation}", { cb: cb })

    # Handles setting subtractive mode
    _subtractiveButtonPressed: (e, name) =>
        @mode = 'subtract'
        name = name.replace('draw-', 'draw:')
        @fire name

    # Handles setting additive mode
    _additiveButtonPressed: (e, name) =>
        @mode = 'add'
        name = name.replace('draw-', 'draw:')
        @fire name

    _drawRectangle: () =>
        $('#map_canvas').addClass('leaflet-pane')
        @current_tool =  new L.Draw.CustomRectangle @map, shapeOptions: (@options.colors?.style?(@mode) ? {})
        @current_tool.options.metric = App.is_metric
        @current_tool.enable()

    _drawPolygon: () =>
        # since we will be using -> later, we need a reference to the current version of this
        self = this

        # these buttons are only enable once a certain number of markers have been placed
        @disableTooltipButton(@finishButton)
        @disableTooltipButton(@deletePointButton)

        # create the handler for drawing polygons
        handler = new L.Draw.NewPoly App.map,
            allowIntersection: false
            shapeOptions: (@options.colors.style(@mode) ? {})

        # modify the options for the marker to make the first one different
        handler.options.icon.options.iconSize.x = 16
        handler.options.icon.options.iconSize.y = 16
        # set the default classes that we want most of the markers to have
        defaultClasses = 'leaflet-marker-icon leaflet-div-icon leaflet-editing-icon leaflet-zoom-animated leaflet-clickable'
        # set the special classes that we want the first marker to have
        handler.options.icon.options.className = 'leaflet-marker-icon custom-marker leaflet-editing-icon leaflet-zoom-animated leaflet-clickable'
        # set the cursor to crosshair when hovering leaflet markers
        $('.leaflet-marker-pane').css('cursor', 'crosshair')
        # when the drawing tools are open and you try to pan, a point will be dropped because events register for both
        # dropping a point and panning the map. On click and on touch events are both fired on a desktop click, the below
        # code overrides the library method as a workaround for that issue
        handler._onTouch = (e) ->
            if e.originalEvent.target.className.indexOf('leaflet-control-pan') > -1
                return
            else
                L.Draw.Polygon.prototype._onTouch.call(this, e)
        # setup an event listener to do things each time a vertex is drawn
        App.map.on(L.Draw.Event.DRAWVERTEX, (one) =>
            if @current_tool.h?._markers?.length > 0
                # once we've laid the first marker, change the marker styling
                @current_tool.h.options.icon.options.iconSize.x = 8
                @current_tool.h.options.icon.options.iconSize.y = 8
                @current_tool.h.options.icon.options.className = defaultClasses
                # enable the delete point button and fire an event so we know that the polygon tool is now active
                @enableTooltipButton(@deletePointButton)
                @fire('mfdraw:polygon-tool-active')

                # if we have enough markers, enable the finish button
                if @current_tool.h._markers?.length >= 3
                    @enableTooltipButton(@finishButton)
        )

        @current_tool = {
            h: handler
            disable: () ->
                # call the handlers disable function
                @h.disable()
                # unregister the listeners we setup for the polygon handler
                App.map.off('mousedown')
                App.map.off(L.Draw.Event.DRAWVERTEX)
                # fire an event so that we know the polygon tool has become inactive
                self.fire('mfdraw:polygon-tool-inactive')
        }

        # enable the handler
        handler.enable()

    # Handle initializing a circle drawing tool
    _drawCircle: () =>
        @current_tool = new L.Draw.BetterCircle App.map, shapeOptions: (@options.colors.style(@mode) ? {})
        @current_tool.options.units = if App.is_metric then 'metric' else 'english'
        @current_tool.enable()

    # Sets up a temp tool that lets people trigger `_polySelected()` once
    # you click on any polygon
    _selectPressed: () =>
        @layer.on 'click', (e) =>
            @_polySelected(e)


    # Enables edit handler once a polygon has been selected
    _polySelected: (e) =>
        @setStyle()
        # ensure we have the right layer
        if e.target isnt @layer
            @fire('zone:select', { layer: e.target })
        # return if the tool is in use
        return if @current_tool?.active is true
        self = this
        cb = () =>
            @_selectPressed()

        @current_tool = {
            h: null
            disable: (from_edit = false) =>
                if not from_edit
                    @_setPgisParams(@layer.toGeoJSON(), null)
                    @_pgis('edit', cb)
                    @fire('draw:shape-added')
                @layer.off 'click', @_polySelected
                @current_tool.finish()
            finish: () ->
                @h?.disable?()
                self.layer.off 'click', @_polySelected
            active: true
        }

        handler = new L.Edit.PolyWithHoles(e.layer, { color: @options.draw.color })
        handler.enable()
        @current_tool.h = handler

        handler.on('geometry-valid', (param) =>
            callback = () =>
                @current_tool.active = false
                @_setPgisParams(param.layer.toGeoJSON(), null)
                @_pgis('edit', cb)
                @fire('draw:shape-added')
                @current_tool.disable(true)
            # remove hooks then callback
            @current_tool?.h?.removeHooks?(callback)
        )
        # Disable the previous selection
        # @current_tool.h?.disable?()

    # Turf union/intersect/difference don't work with feature collections -
    # they're only intended for single geometries. To handle this, we convert
    # the currently drawn geometry into a single multipolygon.
    _getCurrentAsGeojson: () =>
        poly =
            'type': 'Feature'
            'geometry':
                'type': 'MultiPolygon'
                'coordinates': []
        # 'each layer gets its geom coords pushed into poly.geom.coord'
        @layer.eachLayer (l) =>
            gj = l.toGeoJSON().geometry
            coords = gj.coordinates
            if gj.type is 'MultiPolygon'
                for p in coords
                    poly.geometry.coordinates.push p
            else
                poly.geometry.coordinates.push coords
        return poly

    checkNetChange: (layer) ->
        if layer
            return turf.area(layer) is turf.area(@layer.toGeoJSON())

    # Retrieves, unnested, all polygons from the
    # drawing layer
    getAreas: (pusharray = [], start, polynum = 1, units = 'ac') ->
        start ?= @layer

        start.eachLayer (layer) =>
            geojson = layer.toGeoJSON()

            if geojson.geometry.type is 'MultiPolygon'
                pusharray = @addPolygon(turf.polygon(coords), pusharray, units, polynum, start, layer) for coords in geojson.geometry.coordinates
            else
                pusharray = @addPolygon(geojson, pusharray, units, polynum, start, layer)

            polynum++

        return pusharray

    addPolygon: (geojson, pusharray, units, polynum, start, layer) =>
        for ring, ind in geojson.geometry.coordinates
            ft = turf.polygon([ring])

            if units is 'ac'
                area = turf.area(ft) * 0.000247105
            else if units is 'ha'
                area = turf.area(ft) * 0.0001

            if area > 0.000001
                newpoly =
                    number: if ind is 0 then polynum else ind
                    area: area
                    parent_layer: start
                    layer: layer
                    type: if ind is 0 then 'area' else 'hole'

                pusharray.push newpoly

        return pusharray
